import { DefaultState } from './default-state.type';

export const defaultState: DefaultState = {
	showPromotionalDropdown: false,
	selectedPromotionalSku: [],
	removedPromotionalSku: '',
	pricePromotionalSku: [],
	promotionalDescription: [],
	skuPromotionalSku: []
};
